(function () {
  function isEngagementRing() {
    try {
      var tags = window.__productTags || [];
      if (typeof tags === "string") tags = tags.split(",");
      for (var i = 0; i < tags.length; i++) {
        var t = tags[i].trim();
        if (t === "Engagement Rings" || t === "All Engagement") return true;
      }
    } catch (e) {}
    return false;
  }

  
  function normalize(text) {
    return (text || "").trim().toLowerCase();
  }

  function findExistingControls(root) {
    var nodes = Array.from(root.querySelectorAll("*"));
    var map = { ring: null, video: null, stacked: null };

    nodes.forEach(function (node) {
      var key = normalize(node.textContent);
      if (!(key in map) || map[key]) return;
      if (node.children.length > 0) return;
      var clickable = node.closest("button, a, label, [role='button']") || node;
      map[key] = clickable;
    });

    if (map.ring && map.video && map.stacked) return map;
    return null;
  }

  function createControls(root) {
    var controls = document.createElement("div");
    controls.className = "pdp-media-controls";

    ["ring", "video", "stacked"].forEach(function (key) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "pdp-media-controls__item";
      btn.dataset.mediaControl = key;
      btn.textContent = key.charAt(0).toUpperCase() + key.slice(1);
      controls.appendChild(btn);
    });

    root.appendChild(controls);
    return {
      ring: controls.querySelector('[data-media-control="ring"]'),
      video: controls.querySelector('[data-media-control="video"]'),
      stacked: controls.querySelector('[data-media-control="stacked"]'),
    };
  }

  function setActive(controls, key) {
    ["ring", "video", "stacked"].forEach(function (k) {
      if (!controls[k]) return;
      controls[k].classList.toggle("is-active", k === key);
    });
  }

  function isVideoSlide(slide) {
    return !!slide.querySelector("video, iframe, .external-video, .video");
  }

  function getVideoIndex(swiper) {
    var index = null;
    Array.from(swiper.slides || []).forEach(function (slide) {
      if (index !== null) return;
      if (slide.classList.contains("swiper-slide-duplicate")) return;
      var real = Number(slide.dataset.swiperSlideIndex);
      if (Number.isNaN(real)) return;
      if (isVideoSlide(slide)) index = real;
    });
    return index;
  }

  function buildVideoIndexSet(swiper) {
    var set = {};
    Array.from(swiper.slides || []).forEach(function (slide) {
      if (slide.classList.contains("swiper-slide-duplicate")) return;
      var real = Number(slide.dataset.swiperSlideIndex);
      if (Number.isNaN(real)) return;
      if (isVideoSlide(slide)) set[real] = true;
    });
    return set;
  }

  function goTo(swiper, index) {
    if (index === null || typeof index === "undefined") return;
    if (swiper.params && swiper.params.loop && typeof swiper.slideToLoop === "function") {
      swiper.slideToLoop(index);
      return;
    }
    swiper.slideTo(index);
  }

  function bindForGallery(galleryRoot) {
    if (!galleryRoot || galleryRoot.dataset.mediaControlsInit === "true") return;
    galleryRoot.dataset.mediaControlsInit = "true";

    var swiperEl = galleryRoot.querySelector(".swiper-container");
    if (!swiperEl || !swiperEl.swiper) {
      setTimeout(function () {
        galleryRoot.dataset.mediaControlsInit = "false";
        bindForGallery(galleryRoot);
      }, 150);
      return;
    }

    var swiper = swiperEl.swiper;
    var ringIndex = 0;
    var stackedIndex = 2;
    var videoIndex = getVideoIndex(swiper);
    var videoSlides = buildVideoIndexSet(swiper);

    var totalSlides = (swiper.slides || []).length;
    if (swiper.params && swiper.params.loop) {
      var dupes = swiperEl.querySelectorAll(".swiper-slide-duplicate").length;
      totalSlides = totalSlides - dupes;
    }
    var hasVideo = videoIndex !== null;
    var hasStacked = totalSlides >= 3;

    if (!hasVideo && !hasStacked) return;

    var controls = findExistingControls(galleryRoot) || createControls(galleryRoot);

    if (!hasVideo && controls.video) controls.video.style.display = "none";
    if (!hasStacked && controls.stacked) controls.stacked.style.display = "none";

    function syncActive() {
      var idx = swiper.realIndex;
      if (videoSlides[idx]) {
        setActive(controls, "video");
      } else if (idx >= stackedIndex) {
        setActive(controls, "stacked");
      } else {
        setActive(controls, "ring");
      }
    }

    if (controls.ring) {
      controls.ring.addEventListener("click", function (event) {
        event.preventDefault();
        goTo(swiper, ringIndex);
      });
    }
    if (controls.video) {
      controls.video.addEventListener("click", function (event) {
        event.preventDefault();
        if (videoIndex !== null) goTo(swiper, videoIndex);
      });
    }
    if (controls.stacked) {
      controls.stacked.addEventListener("click", function (event) {
        event.preventDefault();
        goTo(swiper, stackedIndex);
      });
    }

    swiper.on("slideChange", syncActive);
    goTo(swiper, ringIndex);
    setTimeout(syncActive, 50);
  }

  function init() {
    if (!isEngagementRing()) return;
    document.querySelectorAll(".top-main.product-gallery").forEach(bindForGallery);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  requestAnimationFrame(init);
  setTimeout(init, 200);
})();
